import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/search",
      },
      queries: [],
    }),
    [],
  );
}

export const useSearchPageNavigator = createPageNavigator<void>({
  useNavigator,
});
